import { v7 as uuid } from "uuid";
import { z } from "zod/v4";
// TODO ニセuuidを弾く必要があるか？
const UUIDSchema = z
    .string()
    .regex(
// ref. https://github.com/colinhacks/zod/blob/981af6503ee1be530fe525ac77ba95e1904ce24a/src/types.ts#L519 を改変
/^([a-f0-9]{8}-?[a-f0-9]{4}-?[1-7][a-f0-9]{3}-?[a-f0-9]{4}-?[a-f0-9]{12}|00000000-?0000-?0000-?0000-?000000000000)$/i)
    // LogiXのUUIDはハイフン無しのUpperCaseを標準とする
    .transform((value) => value.replaceAll("-", "").toUpperCase())
    .brand();
const generate = () => {
    const id = uuid();
    return UUID.schema.parse(id);
};
const equals = (a, b) => a === b;
export const UUID = {
    schema: UUIDSchema,
    generate,
    equals,
};
//# sourceMappingURL=uuid.js.map